import { render } from "./Authenticate.vue?vue&type=template&id=5aa9da52&ts=true"
import script from "./Authenticate.vue?vue&type=script&lang=ts"
export * from "./Authenticate.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/app/releases/1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__